import { render } from "./StockLocationForm.vue?vue&type=template&id=4ceea28d"
import script from "./StockLocationForm.vue?vue&type=script&lang=js"
export * from "./StockLocationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__